

exports.__esModule = true;
exports.isConfigForRulesSummaryEnabled = isConfigForRulesSummaryEnabled;
exports.isConfigForMerchantPreferencesEnabled = isConfigForMerchantPreferencesEnabled;

var _squid = require('squid');

function isConfigForRulesSummaryEnabled() {
    return _squid.$config.readRulesSummaryFromAppData === true || _squid.$config.readRulesSummaryFromAppData === 'true';
}

function isConfigForMerchantPreferencesEnabled() {
    return _squid.$config.readMerchantPreferencesFromAppData === true || _squid.$config.readMerchantPreferencesFromAppData === 'true';
}

_squid.$config;


//////////////////
// WEBPACK FOOTER
// ./js/lib/util.js
// module id = ./js/lib/util.js
// module chunks = 0